<template>
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header id="header" class="mdl-layout__header">
      <div class="mdl-layout-icon">
        <i class="material-icons" v-on:click="cancel">arrow_back_ios</i>
      </div>
      <div class="mdl-layout__header-row">
        <span class="mdl-layout-title"></span>
        <div class="mdl-layout-spacer"></div>
      </div>
    </header>
    <main class="mdl-layout__content">
      <div class="page-content">
        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit">
          <div class="mdl-card__title2">
            {{ formatDate(visit.date) }}<br>
            <h4>{{visit.real_state_name}}</h4>
          </div>
          <div class="mdl-card__supporting-text">
            <ul class='mdl-list'>
              <li class="mdl-list__item mdl-list__item--two-line">
                <span class="mdl-list__item-primary-content">
                  {{visit.visit_type_name}}
                  <span class="mdl-list__item-sub-title">
                    {{visit.visit_text}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.real_state_phone">
                <span class="mdl-list__item-primary-content">
                  Telefones
                  <span class="mdl-list__item-sub-title">
                    {{visit.real_state_phone}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.evaluator">
                <span class="mdl-list__item-primary-content">
                  Gerente
                  <span class="mdl-list__item-sub-title">
                    {{visit.evaluator}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.start_date">
                <span class="mdl-list__item-primary-content">
                  Iniciado em
                  <span class="mdl-list__item-sub-title">
                    {{formatHour(visit.start_date)}}
                  </span>
                </span>
              </li>
              <li class="mdl-list__item mdl-list__item--two-line" v-if="visit.end_date">
                <span class="mdl-list__item-primary-content">
                  Finalizado em
                  <span class="mdl-list__item-sub-title">
                    {{formatHour(visit.end_date)}}
                  </span>
                </span>
              </li>

            </ul>

            <div>
              <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect" v-if="visit.is_simple && visit.is_checkable && visit.end_date == null" disabled>
                Entrada
              </button>
              <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored pull-right" v-on:click="pre_save" v-if="visit.is_simple && visit.end_date == null">
                Saída
              </button>
            </div>

          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit.checklist">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Checklist</h4>
          </div>    
          <div class="mdl-card__supporting-text" v-if="visit.checklist">
            <div v-for="(section, section_index) in visit.checklist" v-bind:key="section.key">
              <hr>
              <h5>{{section.title}}</h5>
              <div class='mdl-list'>
                <div v-for="(item, item_index) in section.items"  v-bind:key="item.key">
                  <div class="mdl-list__item-primary-content">
                    <hr>
                    <div class="checklist-title">{{item_index + 1}}. {{item.title}}</div>
                    <div v-if="item.type == 'boolean'">
                      <i class="material-icons" v-html="radioIcon(section_index, item_index, true)"></i> Sim
                      <i class="material-icons" v-html="radioIcon(section_index, item_index, false)"></i> Não
                    </div>
                    <div v-if="item.type == 'date'">
                      <input type="date" v-bind:id="section.key + '_' + item.key" class="mdl-textfield__input" v-bind:value="item.value" disabled>
                    </div>
                    <div v-if="item.type == '1to5andNA'">
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, '0')"></i> 0
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, '1')"></i> 1
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, '2')"></i> 2
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, '3')"></i> 3
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, '4')"></i> 4
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, '5')"></i> 5
                      <i class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, 'NA')"></i> N/A
                    </div>
                    <div v-if="item.type == 'options'">
                      <span v-for="(option, option_index) in item.options" :key="option_index">
                        <i  class="material-icons checklist-option" v-html="radioIcon(section_index, item_index, option)"></i>
                          {{option}}
                      </span>
                    </div>                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="!visit.is_simple">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Comentários</h4>
          </div>    
          <div class="mdl-card__supporting-text">
            <div v-if="visit.comments">
              {{visit.comments}}
            </div>
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit.is_rateable">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Avaliação</h4>
          </div>    
          <div class="mdl-card__supporting-text">
            <div v-if="visit.status == 'open'">
              Está satisfeito com nossos serviços?<br><br>
            </div>
            <i class="material-icons rating_star" v-on:click="selectStar(1)">{{ starIcon(visit, 1) }}</i><i class="material-icons rating_star" v-on:click="selectStar(2)">{{ starIcon(visit, 2) }}</i><i class="material-icons rating_star" v-on:click="selectStar(3)">{{ starIcon(visit, 3) }}</i><i class="material-icons rating_star" v-on:click="selectStar(4)">{{ starIcon(visit, 4) }}</i><i class="material-icons rating_star" v-on:click="selectStar(5)">{{ starIcon(visit, 5) }}</i>
          </div>
        </div>

        <div id="panel-signature" class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit.is_signable">
          <div class="mdl-card__title">
            <h4 class="mdl-card__title-text">Assinatura</h4>
          </div>    
          <div class="mdl-card__supporting-text">
            <div id="signature"></div>
            <canvas></canvas>
            <button v-on:click="clearSignature" v-if="visit.status == 'open'">Corrigir</button>
            <br>
            Assinado por
            <input type="text" v-model="visit.evaluator">
          </div>
        </div>

        <div class="mdl-card mdl-cell mdl-cell--12-col" v-if="visit.status != 'closed' && !visit.is_simple">
          <div class="mdl-card__supporting-text">
            <br>
            Confira todas as informações e o nome do responsável antes de Finalizar Visita.
            <br>
            <br>
            <div>
              <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored  pull-right" v-on:click="pre_save">
                {{ $t('stop_visit') }}
              </button>            
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>

  import Vue from 'vue'
  import firebase from 'firebase/app'
  import db from './firebaseInit'
  import * as moment from 'moment'
  import SignaturePad from 'signature_pad'
  import localDb from './localDb'

  //import 'material-design-lite'

  if(/Android 4\.[0-3]/.test(navigator.appVersion)){
     window.addEventListener("resize", function(){
        if(document.activeElement.tagName=="INPUT" || document.activeElement.tagName=="TEXTAREA"){
           window.setTimeout(function(){
              document.activeElement.scrollIntoViewIfNeeded();
           },0);
        }
      })
  }

  function resizeCanvas() {
  }

  window.addEventListener("resize", resizeCanvas);

  var instancePath = 'instances/' + process.env.FSM_ENV
  var requestsRef = db.collection(instancePath + '/requests')

  export default {
    data: function() {
      return {
        tab: 0,
        visit: {
        },
        signaturePad: null
      }  
    },
    updated: function() {
      if (this.signaturePad == null) {
        var canvas = document.querySelector("canvas")
        if (canvas != null) {
          var signaturePad = new SignaturePad(canvas)
          this.signaturePad = signaturePad        
          var ratio =  Math.max(window.devicePixelRatio || 1, 1);
          var canvas = document.querySelector("canvas")
          if (canvas != null) {
            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
            signaturePad.clear(); // otherwise isEmpty() might return incorrect value
          }          
        }
      }
    },
    mounted() {
      var data = this

      localDb.visits.where({id: this.$route.params.id}).first().then(function(visit) {
        let base = { comments: '', rating: 0 }
        Object.assign(base, visit);
        data.visit = base
        data.tab = base.checklist ? 0 : 1
        if (!data.visit.is_signable) {
          if (document.getElementById('panel-signature') != null) {
            document.getElementById('panel-signature').classList.add('hidden')
          }
        } else {
          if (visit.status == 'closed') {
            var img = new Image();
            img.src = data.visit.signature
            img.style.width = "100%"
            var canvas = document.querySelector("canvas")
            canvas.classList.add('hidden')
            document.getElementById('signature').appendChild(img)
          }
        }
      })
      componentHandler.upgradeAllRegistered();
    },
    methods: {
      formatDate: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY')
      },      
      formatTime: function(date) {
        return moment(date).format('dddd, DD/MM/YYYY às HH:mm:ss')
      },      
      formatHour: function(date) {
        return moment(date).format('HH:mm')
      },
      starIcon: function(visit, level) {
        if (visit.rating >= level) {
          return 'star'
        } else {
          return 'star_border'
        }
      },
      selectStar: function(level) {
        if (this.visit.status == 'open')
          this.visit.rating = level
      },
      pre_save: function() {
        var data = this;
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition(
            function(position) {
              data.visit.end_coords = position.coords.latitude + ',' + position.coords.longitude;
              data.save()
            },
            function(error) {
              data.visit.end_coords = "Indisponivel (codigo " + error.code + ")";
              data.save()
            }
          );
        } else {
          data.save()
        }        
      },
      save: function() {
        this.visit.status = 'closed'
        if (this.visit.is_signable) {
          if (this.signaturePad)
            this.visit.signature = this.signaturePad.toDataURL()
        }
        this.visit.end_date = moment().toISOString();
        this.visit.sent = false
        localDb.visits.put(this.visit)
        db.doc(instancePath + '/people/' + localStorage.getItem('currentUser')).collection('visits').doc(this.$route.params.id).update(this.visit)
        requestsRef.add({
          key: this.$route.params.id,
          visit: this.visit
        })
        this.$router.push('/calendar')
      },
      cancel: function() {
        this.$router.push('/calendar')
      },
      radioIcon: function(section_key, item_key, value) {
        return ('value' in this.visit.checklist[section_key].items[item_key] && this.visit.checklist[section_key].items[item_key].value == value) ? 'radio_button_checked' : 'radio_button_unchecked'
      },
      back: function() {
        this.$router.go(-1)
      },
      clearSignature: function() {
        this.signaturePad.clear()
      }
    }
  }
</script>
<style scoped>
ul {
  margin: 0px;
  list-style-type: none;
  padding: 0px;
}
li {
  margin: 4px 0;
  display: list-item;
  text-align: -webkit-match-parent;
}
.mdl-list__item {
  padding: 0px;
}
.mdl-card__supporting-text {
  padding-top: 0px;
}
.mdl-list__item--two-line {
  height: 56px;
}
.rating_star {
  font-size: 48px;
}
.mdl-card__title2 {
  padding: 16px;
}
h4 {
  margin-top: 0px;
}
canvas {
  width: 100%;
  min-height: 200px;
  border: 1px solid grey;
}
</style>


// WEBPACK FOOTER //
// src/components/CheckoutView.vue